/** @format */

import {Theme} from '@mui/material/styles';

export const SCROLLBAR_HEIGHT = 17;

type ScrollbarVariants = 'light' | 'dark';

export const scrollbarStyles = (theme: Theme, variant: ScrollbarVariants) => {
  const isDark = variant === 'dark';

  const bg = isDark ? '#3e3e3e' : '#f5f5f5';
  const borderColor = isDark ? '#3e3e3e' : '#f5f5f5';

  return {
    // Firefox
    scrollbarWidth: 'thin' as const,
    scrollbarColor: `#C1C1C1 ${bg}`,

    // Webkit (Chrome, Safari, Edge)
    '&::-webkit-scrollbar': {
      height: `${SCROLLBAR_HEIGHT}px`,
      width: `${SCROLLBAR_HEIGHT}px`,
      background: bg,
      borderRadius: '9px',
    },

    '&::-webkit-scrollbar-thumb': {
      background: '#C1C1C1',
      borderRadius: '8px',
      height: `${SCROLLBAR_HEIGHT - 4}px`,
      marginTop: theme.spacing(0.5),
      marginBottom: theme.spacing(0.5),
      border: `2px solid ${borderColor}`,
    },

    '&::-webkit-scrollbar-track:horizontal': {
      background: bg,
      borderRadius: '0 0 7px 7px',
    },

    '&::-webkit-scrollbar-track:vertical': {
      background: bg,
      borderRadius: '0 7px 7px 0',
    },

    '&::-webkit-scrollbar-corner': {
      display: 'none',
    },
  };
};
